import { Control, Controller, RegisterOptions } from "react-hook-form";
import { NGSelect, NGSelectProps } from "../../../../newcomponents/select/ngselect";

interface FormNGSelectProps<T = any> extends Omit<NGSelectProps<T>, "value" | "onChange"> {
  name: string;
  control: Control<any>;
  rules?: RegisterOptions;
}

export const FormNGSelect = <T = any>({ 
  name, 
  control, 
  rules, 
  ...props 
}: FormNGSelectProps<T>) => {
  return (
    <Controller
      name={name}
      control={control}
      rules={rules}
      render={({ field, fieldState }) => (
        <NGSelect<T>
          {...props}
          value={field.value || ""}
          onChange={(value) => field.onChange(value)}
          invalid={fieldState.invalid || !!fieldState.error}
        />
      )}
    />
  );
};
